import { useEffect } from "react";
import { useNavigate } from "react-router";
import { onboardingStep } from "@/app/onboarding";
import { platform } from "@/platform";
import { useAuthStore } from "@/stores/authStore";
import { usePushStore } from "@/stores/pushStore";
import { pushTargetPath, syncPushToken } from "./push";

/**
 * 앱 셸 1회(AC0-260): ① 알림 탭 → 그 채팅방(/chat/:plotSlug) ② 가입을 마친 회원 세션이 생기면(부팅 복원·로그인·가입) 토큰 등록
 * ③ 포그라운드 복귀 때 아직 등록된 토큰이 없으면 다시(기기 설정에서 알림을 켠 경우). 웹은 platform.push 가 no-op 이라 아무것도 안 한다.
 */
export function usePushBridge(): void {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => (s.status === "member" && onboardingStep(s.user) === null ? (s.user?.id ?? null) : null));

  useEffect(
    () =>
      platform.push.onOpened((data) => {
        const path = pushTargetPath(data);
        if (path) void navigate(path);
      }),
    [navigate],
  );

  useEffect(() => {
    if (userId) void syncPushToken();
  }, [userId]);

  useEffect(() => {
    if (platform.clientKind === "web") return;
    return platform.app.onForeground(() => {
      if (useAuthStore.getState().status === "member" && !usePushStore.getState().token) void syncPushToken();
    });
  }, []);
}
